<template>
  <MainLayout selectMenu="21-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Row class="menu-line menu-actions" type="flex">
        <Col flex="10" class="flex-left">      
    {{ getTranslation('e004') }}:&nbsp;<Tooltip placement="right-end" theme ="light" :transfer="true" max-width="300" >
  <div slot="content" >
            <div v-html="getTranslation('e017')"></div>
        </div>
  <Icon type="md-information-circle" color="#5cadff"  size="20"/></Tooltip>&nbsp;<Select :transfer="true" size="small" v-model="selectGroupType"
          :filterable="true" :placeholder="getTranslation('m034')" style="width:150px" @on-change="search()">
          <Option v-for="item in groupType" :value="item.key" :key="item.key">{{ item.val }}</Option>
        </Select>&nbsp;
        <div v-if="selectGroupType == 'mac_id'">{{ getTranslation('b006') }}:&nbsp;<Input type="text" size="small" style="width:90px;" :placeholder="getTranslation('e029')" v-model="programStart" />&nbsp;-&nbsp;<Input type="text" size="small" style="width:90px;" :placeholder="getTranslation('e030')" v-model="programEnd" @on-enter="getData()"/></div>
        <div v-if="selectGroupType == 'spot_id'"><Input type="text" size="small" :placeholder="getTranslation('e013')" v-model="filterSpotId" @on-enter="getData()"/></div>
        <div v-if="selectGroupType == 'program_id'"><Input type="text" size="small" :placeholder="getTranslation('e014')" v-model="filterProgramId" @on-enter="getData()"/></div>
        <div v-if="selectGroupType == 'vin'">{{ getTranslation('k226') }}: <Input type="text" size="small"  v-model="vinStart" style="width:110px;"/>&nbsp;-&nbsp;<Input type="text" size="small"  style="width:110px;" v-model="vinEnd" @on-enter="getData()"/></div>
       &nbsp;{{ getTranslation('k221') }}:&nbsp;
        <DatePicker size="small" transfer type="daterange" placement="bottom-end" :placeholder="getTranslation('k220')"
          style="width: 210px" v-model="selectDate" format="yyyy-MM-dd">
        </DatePicker>&nbsp;

        <Button type="primary" @click.native="getData()" size="small" shape="circle" icon="ios-search">{{ getTranslation('k176') }}</Button>
        </Col>
        <Col flex="1" class="flex-right">
        <Button type="info" icon="md-cloud-download" size="small" @click.native="exportData()">{{ getTranslation('k025')
        }}</Button>
        </Col>
      </Row>
      <Row class="chart-row" type="flex">
        <Col class="left-fixed">
        <template v-if="selectOptionLoading">
          <div class="spin-container">
            <Spin size="large" fix></Spin>
          </div>
        </template>
        <div v-show="selectGroupType == 'all'">
        </div>
        <div v-show="selectGroupType == 'pl_id'">
          <ExpulsionPl :plData="plData" @updateSelectedPlIds="updateSelectedPlIds"></ExpulsionPl>
        </div>
        <div
          v-show="selectGroupType == 'mac_id' || selectGroupType == 'spot_id' || selectGroupType == 'program_id'">
          <ExpulsionMac :macData="macData" @updateSelectedMacIds="updateSelectedMacIds"></ExpulsionMac>
        </div>
        <div v-show="selectGroupType == 'car_model'">
          <ExpulsionCarModel :carModelData="carModelData" @updateSelectedCarModelIds="updateSelectedCarModelIds">
          </ExpulsionCarModel>
        </div>
        </Col>
        <Col class="middle-echarts">          
                    
        <div  class="chart-wrapper" ref="chartWrapper">
          <div v-if = "chartLoading" class="chart-spin-container">
            <Spin size="large" fix></Spin>
          </div> 
          <div  ref="runningEcharts" :style="{ width: chartWidth, height: '600px' }"></div>
        </div>
        </Col>
        <Col class="right-fix">
          <template v-if="data.records">
          <Row type="flex" class="table-header">
            <Col flex="1" class="table-cell flex-center">{{ getTranslation('e016') }}</Col>
            <Col flex="2" class="table-cell flex-center">{{ Dimensiontitle }}</Col>
            <Col flex="2" class="table-cell flex-center sortable" @click.native="toggleSort('ExpulsionCount')">{{ getTranslation('e007') }}
                <template v-if="sortKey!=='ExpulsionCount'">
                <img class="sort-img"  src="@/assets/img/sort-1.png"  />
                </template>
                <template v-else>
                <Icon :type="sortKey==='ExpulsionCount' ? (sortOrder==='asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
                </template>
            </Col>
            <Col flex="2" class="table-cell flex-center sortable" @click.native="toggleSort('TotalCount')">{{ getTranslation('e008') }}
              <template v-if="sortKey!=='TotalCount'">
              <img class="sort-img"  src="@/assets/img/sort-1.png"  />
              </template>
              <template v-else>
              <Icon :type="sortKey==='TotalCount' ? (sortOrder==='asc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
              </template>
            </Col>
            <Col flex="2" class="table-cell flex-center sortable" @click.native="toggleSort('ExpulsionRate')">{{ getTranslation('e010') }}(%)
              <template v-if="sortKey!=='ExpulsionRate'">
              <img class="sort-img"  src="@/assets/img/sort-1.png"  />
              </template>
              <template v-else>
              <Icon :type="sortKey==='ExpulsionRate' ? (sortOrder==='desc' ? 'md-arrow-up' : 'md-arrow-down') : 'md-swap'" class="sort-icon" />
              </template>
            </Col>
          </Row>
          <Row type="flex" v-for="(record, index) in data.records" :key="index" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']">
            <Col flex="1" class="table-cell">{{ index + 1 }}</Col>
            <Col flex="2" class="table-cell">{{ record.DimensionName }}</Col>
            <Col flex="2" class="table-cell">{{ record.ExpulsionCount }}</Col>
            <Col flex="2" class="table-cell">{{ record.TotalCount }}</Col>
            <Col flex="2" class="table-cell " >{{ 100-record.ExpulsionRate }}%  
              </Col>
          </Row>
          </template> 
        </Col>
      </Row>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Row, Col, Button, Select, Option, DatePicker, Spin,Input,Icon,Tooltip } from 'view-design';

import { mapGetters, mapState } from 'vuex'
import { postJsError, formatUTCDate, blobToString, exportFile } from '@/util/util.js'
import NoAuth from '@/components/NoAuth.vue'
import ExpulsionPl from './components/ExpulsionPl.vue';
import ExpulsionMac from './components/ExpulsionMac.vue';
import ExpulsionCarModel from './components/ExpulsionCarModel.vue';

export default {
  name: 'MachineIndex', // 组件名称
  components: {
    MainLayout, Row, Col, Button, Select, Option, NoAuth, DatePicker, ExpulsionPl, ExpulsionMac, ExpulsionCarModel, Spin, Input, Icon, Tooltip
  },
  props: {

  },
  data() {
    return {
      hasAuth: true,
      selectDate: [new Date(), new Date()],
      selectGroupType: 'pl_id',
      lastGroupType: 'pl_id',
      data: {},
      chartWidth: '100%',
      barWidth: 26, // fixed bar width in px
      machineAndPlData: [],
      selectedMacIds: [],
      plData: [],
      macData: [],
      myChart: null,
      selectedPlIds: [], // keep selected node ids
      isFirstSelect: true,
      selectOptionLoading: false,
      originCarModelData: [],
      carModelData: [],
      selectedCarModelIds: [],
      filterSpotId: '',
      filterProgramId: '',
      sortKey:'',
      sortOrder:'asc',
      chartLoading:false,
      programStart:"",
      programEnd:"",
      vinStart:"",
      vinEnd:"",
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    ...mapState(['queryDate']),
    groupType() {
      return [
        { key: 'pl_id', val: this.getTranslation('u045') },
        { key: 'mac_id', val: this.getTranslation('u048') },
        { key: 'spot_id', val: this.getTranslation('e005') },
        { key: 'program_id', val: this.getTranslation('b040') },
        { key: 'car_model', val: this.getTranslation('k245') },
        { key: 'vin', val: this.getTranslation('k226') },
        { key: 'all', val: this.getTranslation('e018') },
      ]
    },
    Dimensiontitle() {
      return this.groupType.find(g => g.key === this.selectGroupType)?.val || '';
    }
  },
  mounted() {

  },
  created() {
    this.initChart();
    this.initData();
    this.setBreadcrumbItems();    
    this.getData();
  },
  methods: {
    initChart() {
      this.$nextTick(() => {
        const parentWidth = this.$refs.chartWrapper?.offsetWidth || this.$refs.runningEcharts.offsetWidth;
        this.chartWidth = `${parentWidth}px`;
        this.myChart = this.$echarts.init(this.$refs.runningEcharts);
      })


    },
    async getData() {     
      // ensure selected ids are up-to-date    
      this.chartLoading=true;  
      let url = API_URL["expulsionGet"];
      this.$store.commit('setQueryDate', this.selectDate)
      let formData = this.buildFormData();
      let res = await axios.post(url, formData, { timeout: 300000 })       
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c019'));
        })
      this.chartLoading=false;
      if (res && res.data && res.data.code == 200) {
          this.data = res.data.data || {};
          this.renderChart();
        } else if (res && res.data && res.data.code == 3001) {
          this.hasAuth = false;
        } else if (res && res.data && res.data.msg) {
          this.$Message.error(res.data.msg);
        }
      
    },
    buildFormData() {
      let formData = new FormData();
      formData.append('groupType', this.selectGroupType);
      formData.append('start', formatUTCDate(this.selectDate[0]));
      formData.append('end', formatUTCDate(this.selectDate[1]));
      let ids = this.selectedPlIds.join(',');
      let macIds = this.selectedMacIds.join(',');
      formData.append('selectedPlIds', ids);
      formData.append('selectedMacIds', macIds);
      formData.append('selectedCarModelIds', this.selectedCarModelIds.join(','));      
      formData.append('filterProgramId', this.filterProgramId.trim());
      formData.append('programStart', this.programStart.trim());
      formData.append('programEnd', this.programEnd.trim());
      formData.append('vinStart', this.vinStart.trim());
      formData.append('vinEnd', this.vinEnd.trim());
      return formData;
    },
    initData() {
      if (this.queryDate && this.queryDate.length > 0) {
        this.selectDate = [...this.queryDate]
      }
      this.search();
    },
    refreshPage() {
      this.getData();
    },
    async search() {
      this.selectOptionLoading = true;
      if (this.selectGroupType == 'pl_id' || this.selectGroupType == 'mac_id' ||
        this.selectGroupType == 'spot_id' || this.selectGroupType == 'program_id') {        
        if (this.machineAndPlData.length == 0) {
          let url = API_URL["productlineGetWithMachine"];
          let res = await axios.get(url)
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
          if (res && res.data && res.data.code == 200) {
            this.machineAndPlData = res.data.data;
          }
          this.processData();
        }
        
      }
      if (this.selectGroupType == 'car_model') {
        
        if (this.originCarModelData.length == 0) {
          let url = API_URL["expulsionGetCarModelData"];
          let res = await axios.get(url)
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })
          if (res && res.data && res.data.code == 200) {
            this.originCarModelData = res.data.data.carModels;
            this.processCarModelData();
          }
        }
      }
      this.selectOptionLoading = false;
    },
    onGroupTypeChange(newVal) {
      const samePool = new Set(['mac_id', 'spot_id', 'program_id']);
      const wasIn = samePool.has(this.lastGroupType);
      const nowIn = samePool.has(newVal);
      // v-model already updated selectGroupType; just decide fetching options
      if (!(wasIn && nowIn)) {
        // only fetch when moving in/out of the mac/spot/program pool
        this.search();
      }
      this.lastGroupType = newVal;
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['e001']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('e001') }
        ])
      }     
    },
    percent(num, total) {
      if (total === 0) {
        return '0%';
      }
      return ((num / total) * 100).toFixed(2) + '%';
    },
    getAxisLabelRotation(categories) {
      const maxLen = categories.reduce((m, c) => Math.max(m, (c || '').length), 0);
      let cLength = categories.length;
      if (maxLen * cLength <= 36 || maxLen <= 6) return 0;
      if (maxLen * cLength <= 60 || maxLen <= 10) return 20;
      if (maxLen * cLength <= 96 || maxLen <= 16) return 30;
      return 45;
    },
    processData() {
      this.machineAndPlData = this.machineAndPlData.filter(pl => Array.isArray(pl.machines) && pl.machines.length > 0);
      let treeData = this.machineAndPlData.map(pl => {
        let plNode = {
          name: pl.name,
          id: pl.id,
          isMachine: false,
          children: [],
          selected: false,
        };
        (pl.machines || []).forEach(mac => {
          let macNode = {
            name: mac.code,
            isMachine: true,
            state: mac.state,
            selected: false,
            id: mac.id,
            pl_id: mac.pl_id,
          };
          plNode.children.push(macNode);
        });
        return plNode;
      });          
      this.macData = treeData;
      let plData = this.machineAndPlData.map(pl => {
        let plNode = {
          name: pl.name,
          id: pl.id,
          isMachine: false,
          children: [],
          selected: false,
        };        
        return plNode;
      });
      this.plData = plData;
    },
    processCarModelData() {
      let treeData = this.originCarModelData.map((model, index) => {
        return {
          name: model,
          id: index,
          isMachine: false,
          children: [],
          selected: false,
        };
      });
      this.carModelData = treeData;
    },

    updateSelectedPlIds() {
      this.selectedPlIds = this.collectSelectedIds(this.plData);
    },
    updateSelectedMacIds() {
      this.selectedMacIds = this.collectSelectedIds(this.macData);
    },
    updateSelectedCarModelIds() {
      this.selectedCarModelIds = this.collectSelectedValues(this.carModelData);
    },
    // gather ids from selected nodes (both pl and machine if id exists)
    collectSelectedIds(treeArr) {
      const out = [];
      const walk = (nodes) => {
        (nodes || []).forEach(n => {
          if (n.selected && n.id != null) out.push(n.id);
          if (Array.isArray(n.children) && n.children.length) walk(n.children);
        });
      };
      walk(treeArr || []);
      return out;
    },
    collectSelectedValues(treeArr) {
      const out = [];
      const walk = (nodes) => {
        (nodes || []).forEach(n => {
          if (n.selected && n.name != null) out.push(n.name);
          if (Array.isArray(n.children) && n.children.length) walk(n.children);
        });
      };
      walk(treeArr || []);
      return out;
    },
    renderChart() {      
      let records = this.data.records || [];
      const list = Array.isArray(records) ? records : [];
      if (list.length === 0) {
        this.myChart.clear();
        return;
      }
      const categories = list.map(d => d?.DimensionName ?? '-');
      const expulsion = list.map(d => Number(d?.ExpulsionCount) || 0);
      const total = list.map(d => Number(d?.TotalCount) || 0);
      const percentages = expulsion.map((e, i) => {
        const t = total[i];
        return t > 0 ? +(100-e * 100 / t).toFixed(2) : 0;
      });
      const remainder = total.map((t, i) => Math.max(t - expulsion[i], 0));

      // set canvas width based on number of bars to keep fixed width
      const parentWidth = this.$refs.chartWrapper?.offsetWidth || 800;
      const perBarExtra = 4; // approximate gap per category
      const desiredWidth = Math.max(parentWidth, categories.length * (this.barWidth + perBarExtra) + 40);
      this.chartWidth = `${desiredWidth}px`;
      if (!this.myChart) {
        this.initChart();
      }
      let Dimensiontitle = this.groupType.find(g => g.key === this.selectGroupType)?.val || '';
      let title = this.getTranslation('e004') + ':[ ' + Dimensiontitle + ' ]';
      title += '  ' + this.getTranslation('k222') + ` [ ${formatUTCDate(this.selectDate[0])} ~ ${formatUTCDate(this.selectDate[1])} ]`;
      const axisLabelRotate = this.getAxisLabelRotation(categories);
      const option = {
        title: {
          text: title, show: true, left: 'center', top: 1, textVerticalAlign: 'top',          
          textStyle: { fontSize: 14, fontWeight: 'normal' }, padding: [0, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            const i = params?.[0]?.dataIndex ?? 0;
            return `${Dimensiontitle}: ${categories[i]}<br/>${this.getTranslation('e007')}: ${expulsion[i]} <br/>${this.getTranslation('e008')}: ${total[i]}<br/>${this.getTranslation('e010')}: ${percentages[i]}%`;
          }
        },
        toolbox: {
          feature: {
            saveAsImage: {},            
          }
        },
        legend: { show: false },
        grid: { left: 20, right: 20, top: 30, bottom: axisLabelRotate > 0 ? 80 : 40 },
        xAxis: { type: 'category', data: categories, axisLabel: { rotate: axisLabelRotate } },
        yAxis: { type: 'value' },
        series: [
          {
            name: this.getTranslation('e008'),
            type: 'bar',
            stack: 'total',
            data: remainder,
            barWidth: this.barWidth,
          },
          {
            name: this.getTranslation('e007'),
            type: 'bar',
            stack: 'total',
            data: expulsion,
            color: '#ff4d4f',
            barWidth: this.barWidth,
            label: {
              show: true,
              position: 'top',
              formatter: (p) => `${percentages[p.dataIndex]}%`
            }
          }
        ]
      };
      this.myChart.clear();
      this.myChart.setOption(option, true);
      this.myChart.resize();
    },
    async exportData() {
      const formData = this.buildFormData();
      const exportUrl = API_URL["expulsionExport"];
      const response = await axios.post(exportUrl, formData, {
        responseType: 'blob',
        timeout: 300000
      });
      if (response.status == 200) {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
            }
          }).catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
          exportFile(response)
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
    },
    toggleSort(key) {      
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortKey = key;
        this.sortOrder = 'asc';
      }
      this.data.records.sort((a, b) => {
        let valA = a[key];
        let valB = b[key];
        if (this.sortOrder === 'asc') {
          return valA - valB;
        } else {
          return valB - valA;
        }
      });
      this.renderChart();
    }
  }
}
</script>

<style>
@import url("../../assets/style/list.css");
@import url("../../assets/style/tab.css");

/* fixed-width bars with horizontal scroll when too many categories */
.chart-wrapper {
  width: 100%;

  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  /* smoother on mobile */
}

/* prevent columns from wrapping and set fixed/growing behavior */
.chart-row {
  flex-wrap: nowrap;
  overflow: hidden;
  /* keep the row from expanding horizontally */
}

.left-fixed {
  height: 650px;
  overflow-y: auto;
  flex: 0 0 260px;
  /* adjust fixed width as needed */
  max-width: 260px;
  background-color: #fbfbfb;
}

.middle-echarts {
  flex: 1;
  /* constrain to available space */
  min-width: 0;
  /* allow inner overflow to be visible */
  overflow: hidden;
  /* prevent the column from growing with content */
}
.right-fix {
  padding-left: 4px;
  height: 650px;
  overflow-y: auto;
  flex: 0 0 450px;
  /* adjust fixed width as needed */
  max-width: 450px;
}

.left-fixed .ivu-tree-arrow {
  display: none;
}

.spin-container {
  display: inline-block;
  width: 100%;
  height: 400px;
  position: relative;
  border: 1px solid #eee;

}
.chart-spin-container{
  float:left; 
  width: 100%;
  height: 600px;
  position: absolute;
  top:0;
  left:0;
  background-color: rgba(255, 255, 255, 1);
  z-index: 10;
  border-radius:4px;
  text-align: center;
  padding-top: 250px;
}
.sortable {
  cursor: pointer;
  user-select: none;
}
.sort-icon {
  margin-left: 6px;
  font-size: 12px;
  vertical-align: middle;
  color: #808695;
}
.sort-img{
  width: 12px;  
  vertical-align: middle;
  margin-left: 2px;
}
</style>
